/**
 * Single source of truth for chat/call setup — mirrors the shape of a
 * typical "chatConfig" object so App.js only has to define this once.
 *
 * Fill in the values for your environment. `apiUrl` should point at the
 * `/api` prefix your server-example mounts its routes under.
 */
export const chatConfig = {
  // Your reference server (server-example) — Socket.IO + REST live on the same host here.
  socketUrl: 'https://talo-backend.digiport.online',
  apiUrl: 'https://talo-backend.digiport.online/api',

  // Identifies this website/package installation to your backend
  // (matched against PACKAGE_API_KEY in server-example/.env).
  apiKey: 'a5301da5806a1926fde2baf56a96c4331ddf4a7036d039db',

  // Which app build embeds this package: user | agent | dev
  userType: 'user',

  // A shared/default room to open on load — can be a friendly name like
  // "support" (auto-created on first use) or a real Chat._id.
  defaultRoom: 'support',

  // Floating chat button placement
    launcherHorizontal: 'right', // 'left' | 'right'
    launcherVertical: 'bottom', // 'top' | 'bottom'
    launcherOffsetYPercent: 4, // % from top or bottom
    launcherOffsetXPercent: 3, // % from left or right
    showLauncher: true, // false = only open via custom button / openTeloChat()
  
    // Web Push public VAPID key from server-example/.env
    vapidPublicKey: 'BBJsxITr8PMB6J2FTYC9rh6dG4genFMoQmQMFWaYuKL35SQupZBI5s29gSspoqEWQQ42jxzrtQpOE_TO7gslfpo',
};
